import React from 'react';

import { CollectionFieldSelector } from 'craft/components/SelectedToolbar/Collections';
import { ComponentButton } from 'craft/components/SelectedToolbar/ComponentButton';
import { InteractionsButton } from 'craft/components/SelectedToolbar/InteractionsButton';
import { useMultiNodes, useSelection } from 'craft/hooks';
import { useResolver } from 'craft/hooks/useResolver';
import { useComponentSchema } from 'craft/state';

import { ContextMenuButton } from './ContextMenuButton';
import { CopyButton } from './CopyButton';
import { DeleteButton } from './DeleteButton';
import { Separator } from './Separator';
import { TextFromACollectionMessage } from './TextFromACollectionMessage';

export const ToolbarMenuBody = () => {
  const { selection } = useSelection();
  const { type } = useMultiNodes(selection.all);
  const resolver = useResolver(type);
  const componentSchema = useComponentSchema(type);

  const customToolbarItems = resolver?.selectedToolbar?.customItems ?? [];

  return (
    <>
      <TextFromACollectionMessage />
      <CopyButton />
      <DeleteButton />

      <CollectionFieldSelector />
      {customToolbarItems.map((CustomItem) => (
        // Changing selection should result in a new set of CustomItems
        <CustomItem key={`${selection.all.join('_')}_${CustomItem.name}`} />
      ))}
      <Separator />
      <ComponentButton />
      {componentSchema?.actions && <InteractionsButton />}
      <Separator />
      <ContextMenuButton />
    </>
  );
};
